(function () {
  'use strict';

  var customState = {};

  var customMetalColors = {
    'Yellow Gold': '#d4ac54',
    'White Gold': '#d8dadd',
    'Rose Gold': '#c99183',
    Platinum: '#c9ced2',
    Silver: '#bfc5c9',
    'Not sure yet': '#d8dadd',
  };
  var customStoneColors = {
    'Lab-grown Diamond': '#f7f7f2',
    'Natural Diamond': '#f4f5f3',
    Sapphire: '#5f7fa7',
    Emerald: '#496b59',
    Ruby: '#9a4350',
    'Other Gemstone': '#b79cc7',
  };
  var shapeStyles = {
    Round: ['50%', 'none'],
    Oval: ['50%', 'scaleX(.78)'],
    Pear: ['52% 52% 58% 42%', 'rotate(45deg)'],
    Emerald: ['5px', 'none'],
    Princess: ['3px', 'rotate(45deg) scale(.82)'],
    Radiant: ['10px', 'none'],
    Marquise: ['50% 50% 50% 50%', 'scaleX(.55) rotate(45deg)'],
    Cushion: ['22px', 'none'],
    Heart: ['48% 48% 55% 55%', 'rotate(45deg)'],
    'Not sure yet': ['50%', 'none'],
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('customInquiry')) return;
    initStudio();
  });

  function scrollToNextStep() {
    var target = document.getElementById('designStudio') || document.getElementById('customInquiry');
    target?.scrollIntoView({ behavior: 'smooth' });
  }

  function initStudio() {
    var fieldMap = {
      project: 'fieldProject',
      shape: 'fieldShape',
      metal: 'fieldMetal',
      stoneType: 'fieldStoneType',
      style: 'fieldStyle',
      occasion: 'fieldOccasion',
      contact: 'fieldContactMethod',
    };

    document.querySelectorAll('[data-studio-group]').forEach(function (group) {
      var active = group.querySelector('button.active') || group.querySelector('button');
      if (active) customState[group.dataset.studioGroup] = active.dataset.value;
    });
    var activeContact = document.querySelector('.contact-method.active') || document.querySelector('.contact-method');
    customState.contact = activeContact ? activeContact.dataset.value : 'Video Call';

    function updateBoard() {
      var board = document.querySelector('.studio-board');
      if (board) {
        board.style.setProperty('--board-metal', customMetalColors[customState.metal] || '#d8dadd');
        board.style.setProperty('--board-stone', customStoneColors[customState.stoneType] || '#f7f7f2');
        var style = shapeStyles[customState.shape] || shapeStyles.Round;
        board.style.setProperty('--board-radius', style[0]);
        board.style.setProperty('--board-transform', style[1]);
      }

      var pairs = {
        project: ['projectLabel', 'summaryProject', 'boardProject'],
        shape: ['shapeLabel', 'summaryShape'],
        metal: ['customMetalLabel', 'summaryMetal'],
        stoneType: ['stoneTypeLabel', 'summaryStoneType'],
        style: ['styleLabel', 'summaryStyle'],
        occasion: ['occasionLabel', 'summaryOccasion'],
      };
      Object.keys(pairs).forEach(function (key) {
        pairs[key].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.textContent = customState[key];
        });
      });

      var aesthetic = document.getElementById('boardAesthetic');
      if (aesthetic) aesthetic.textContent = customState.style + ' · ' + customState.shape + ' · ' + customState.metal;

      Object.keys(fieldMap).forEach(function (key) {
        var input = document.getElementById(fieldMap[key]);
        if (input) input.value = customState[key];
      });
    }

    document.querySelectorAll('[data-studio-group]').forEach(function (group) {
      group.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (item) { item.classList.remove('active'); });
          button.classList.add('active');
          customState[group.dataset.studioGroup] = button.dataset.value;
          updateBoard();
        });
      });
    });

    document.querySelectorAll('.custom-preset').forEach(function (button) {
      button.addEventListener('click', function () {
        customState.project = button.dataset.project;
        var projectGroup = document.querySelector('[data-studio-group="project"]');
        if (projectGroup) {
          projectGroup.querySelectorAll('button').forEach(function (item) {
            item.classList.toggle('active', item.dataset.value === customState.project);
          });
        }
        updateBoard();
        scrollToNextStep();
      });
    });

    document.getElementById('startStudio')?.addEventListener('click', scrollToNextStep);
    document.getElementById('continueInquiry')?.addEventListener('click', function () {
      document.getElementById('customInquiry')?.scrollIntoView({ behavior: 'smooth' });
    });

    document.querySelectorAll('.contact-method').forEach(function (button) {
      button.addEventListener('click', function () {
        document.querySelectorAll('.contact-method').forEach(function (item) { item.classList.remove('active'); });
        button.classList.add('active');
        customState.contact = button.dataset.value;
        var input = document.getElementById(fieldMap.contact);
        if (input) input.value = customState.contact;
      });
    });

    updateBoard();
  }
})();
